import React, { useState } from "react";

class FormulaInput extends React.Component {
    handleChange = (e) => {
        const value = e.target.value;
        this.props.onChange(value);
    }

    render() {
        return (
            <input className="FormulaInput"
                value={this.props.value}
                onChange={this.handleChange}
            />
        );
    }
}

export default FormulaInput